import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity, Platform, InputAccessoryView } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import BarcodeScannerComponent from "../widgets/BarCodeScannerComponent";
import colors from "../../constants/colors";
import SearchInventory from "./searchInventoryTypes";
import SearchIngredientsByLot from "./searchIngredientsByLot";
import { getIngredientLotsByName } from "../../actions/submissions";
//import { Audio } from 'expo-av';
import { getComponentByanotherComponentId, getComponentSubmit, getIosCellHeight, getLotCodeString, getComponentSubmissionByDefaultLabel, getTotalSelected, getRequiredAmount, inputFocus, validateDecimals, lotFieldHasMeaningfulLots, receivingRowHasProductForLotsPicker, shouldOpenLotsPickerMobile } from "../../utils";
import KeyboardBar from "../widgets/KeyboardBar";
import LotsByLocation from "../widgets/LotsByLocation";
import { isMobileWeb, getNoAutofillProps, noAutofillRef } from "../../utils/mobileWeb";

class Lotcode extends Component {
  inputRef = createRef();
  _interval = null;
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.initial,
      dialogVisible: false,
      height: (props.isRecipe && props.defaultLabel == "lot") || !props.isInventoryReceivingForm ? 50 : 27,
      heightIOS: (props.isRecipe && Platform.OS == "ios" && props.defaultLabel == "lot") ? 44 : 27,
      reset: false,
      ingredientOptions: (props.complete_date && props.isRecipe && props.options) ? props.options : [],
      ingredientName: "",
      scan: false,
      showLotsByLocation: false,
      inputAccessoryViewID: 'lot-' + props.id + '-' + props?.position,
      minorAmount: false,
      loadedLots: false,
      scanerCanceled: false,
      leftWriting: typeof this.props.initial == "string" && this.props.initial ? true : (typeof this.props.initial == "object" && getLotCodeString(this.props.initial)) ? true : false,
      quantity: -1,
      quantityChanged: false,
      loadingBatchSizeChange: false,
      softFocus: props.scannerInput ? false : true
    };
    this.textInputRef = createRef(null); 
    this._lotsViewGen = 0;
    /** After closing embedded LotsByLocation, block auto-reopen (focus refire / delayed callbacks). */
    this._embeddedLotsClosedUntil = 0;
  }

  shouldAllowEmbeddedLotsView() {
    return Date.now() >= this._embeddedLotsClosedUntil;
  }
  componentDidMount() {
    const { showInventorySearch, isRecipe, components, position, submission, defaultLabel, section_id, showWipSearch, isInvoice, isInventoryTransfer, isShipmentLog, newReport, status, initial, id, updateComponentLotCodeschoiceList, complete_date } = this.props;

    if ((showInventorySearch || showWipSearch || (isShipmentLog && defaultLabel == "lotcode")) && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog) && !(isRecipe && complete_date)) {
      var sectionComponent = components.find((c, idx) => (c?.type == "section") && (section_id == c.section_id));
      var ingredientComponent = components.filter((c, idx) => (c?.defaultLabel == "ingredient" || c?.defaultLabel == "name" || c?.defaultLabel == "item" || c?.defaultLabel == "itemName") && (section_id == c.section_id));
      var ingredientName = "";
      if (ingredientComponent?.length > 0) {
        var ingredientComponentId = ingredientComponent[0].id;
        if (submission[ingredientComponentId]) {
          if (submission[ingredientComponentId][position]) {
            ingredientName = submission[ingredientComponentId][position];
            if (ingredientName && ingredientName != this.state.ingredientName) {
              var data = {
                name: ingredientName,
                type: (ingredientComponent[0]?.defaultLabel == "ingredient" || ingredientComponent[0]?.defaultLabel == "itemName") ?
                  showWipSearch ?
                    "wip" : "ingredient" : ((isInventoryTransfer || isShipmentLog) && ingredientComponent[0]?.defaultLabel == "item") ?
                    sectionComponent?.defaultLabel == "finishedGoods" ?
                      "fg" : sectionComponent?.defaultLabel == "workInProgress" ?
                        "wip" : sectionComponent?.defaultLabel == "packagingMaterials" ?
                          "packagingMaterial" : "ingredient" : isInvoice ?
                      "fg" : "packagingMaterial"
              }
              if (isRecipe) data.forRecipe = true;
              this.setState({ ingredientName });
              this.props.getIngredientLotsByName(data, (res) => {
                if (res?.lots?.length) {
                  var val = [];
                  this.setState({ ingredientOptions: res.lots }, () => {
                    //Save actual lotcodes in component choice list
                    if(updateComponentLotCodeschoiceList)updateComponentLotCodeschoiceList(id, res.lots, position);
                  });
                  //Set First lot code as prefilled data
                  var initialValue = initial ? initial : "";
                  if ((!status || status == "in_progress") && !isShipmentLog && (!initial || typeof initial == "object" && initialValue[0] == "default_lot")) {
                    var p = (position + 1) * 300;
                    //val.push(res.lots[0]);
                    val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(res?.lots)));
                    //Wait to submission be updated correctly
                    //if (!isInvoice)
                      setTimeout(() => {
                        this.onSelectItem(val, true);
                        this.setState({ loadedLots: true });
                      }, p);
                  }
                } else {
                  this.setState({ loadedLots: true });
                }
              });
            } else {
              this.setState({ loadedLots: true });
            }
          }
        }
      }
    }
  }
  componentWillUnmount() {
    if(this._interval)clearTimeout(this._interval);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showInventorySearch, isRecipe, components, position, defaultLabel, section_id, showWipSearch, isInvoice, isInventoryTransfer, isShipmentLog, id, onChange, openBarCodeScanner, focusLotCode, handleFocusOnElement, complete_date, isReceivingLog } = this.props;
    const { submission, quantityChangedPosition } = nextProps;

    if (nextProps.initial != this.props.initial) {
      this.setState({ value: nextProps.initial });
    }
    if (isRecipe && nextProps.focusLotCode != focusLotCode && nextProps.focusLotCode >= 0 && defaultLabel == "lot" && position == nextProps.focusLotCode) {
      if (handleFocusOnElement && this.textInputRef.current) {
        this.textInputRef.current.focus();
        //handleFocusOnElement(this.textInputRef.current);
      }
    }
    if (nextProps?.resetInventorySearch) {
      if ((nextProps?.resetInventorySearch?.changed != this.props.resetInventorySearch?.changed && nextProps?.resetInventorySearch?.position == this.props?.position && (isShipmentLog || isInventoryTransfer) && (this.props?.defaultLabel == 'lotcode_finished' || this.props?.defaultLabel == 'lotcode_wip' || this.props?.defaultLabel == 'lotcode'))) {
        this.setState({ value: nextProps.initial, reset: !this.state.reset, ingredientOptions: [] });
      }
    }
    var ingredientComponent = components ? components.filter((c, idx) => (c?.defaultLabel == "ingredient" || c?.defaultLabel == "packagingMaterial" || c?.defaultLabel == "name" || c?.defaultLabel == "item" || c?.defaultLabel == "itemName") && (section_id == c.section_id)) : null;
    if (ingredientComponent?.length > 0) {
      var ingredientComponentId = ingredientComponent[0].id;
      if (submission[ingredientComponentId]) {
        if (!submission[ingredientComponentId][position] && submission[ingredientComponentId][position] != this.state.ingredientName) {
          this.setState({ ingredientName: "" });
        }
      }
    }
    //Show lots for item added in recipes
    if ((showInventorySearch || showWipSearch || (isShipmentLog && defaultLabel == "lotcode")) && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog
      //|| (isRecipe && this.props.batchSizeChanged != nextProps.batchSizeChanged)
    ) && !(isRecipe && complete_date)) {
      var sectionComponent = components.find((c, idx) => (c?.type == "section") && (section_id == c.section_id));
      //var ingredientComponent = components.filter((c, idx) => (c?.defaultLabel == "ingredient" || c?.defaultLabel == "name" || c?.defaultLabel == "item" || c?.defaultLabel == "itemName") && (section_id == c.section_id));
      //var ingredientName = "";
      if (ingredientComponent?.length > 0) {
        var ingredientComponentId = ingredientComponent[0].id;
        if (submission[ingredientComponentId]) {
          if (submission[ingredientComponentId][position]) {
            var ingredientName = submission[ingredientComponentId][position];
            if (ingredientName && (ingredientName != this.state.ingredientName
              //|| this.props.batchSizeChanged != nextProps.batchSizeChanged
            )) {
              var data = {
                name: ingredientName,
                type: (ingredientComponent[0]?.defaultLabel == "ingredient" || ingredientComponent[0]?.defaultLabel == "itemName") ?
                  showWipSearch ?
                    "wip" : "ingredient" : ((isInventoryTransfer || isShipmentLog) && ingredientComponent[0]?.defaultLabel == "item") ?
                    sectionComponent?.defaultLabel == "finishedGoods" ?
                      "fg" : sectionComponent?.defaultLabel == "workInProgress" ?
                        "wip" : sectionComponent?.defaultLabel == "packagingMaterials" ?
                          "packagingMaterial" : "ingredient" : isInvoice ?
                      "fg" : "packagingMaterial"
              }
              if (isRecipe) data.forRecipe = true;
              this.setState({ ingredientName });
              this.props.getIngredientLotsByName(data, (res) => {
                if (res?.lots?.length) {
                  //if(nextProps.lotcodeFirstPreselection){
                  //  this.onSelectItem(["default_lot"], true);
                  //}
                  if (!isShipmentLog) {
                    var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(res?.lots)));
                    this.onSelectItem(val, true);
                  }
                  this.setState({ ingredientOptions: res.lots });
                } else if (res?.lots?.length <= 0 && typeof this.state.value == "object" && this.state.value[0] == "default_lot") {
                  this.setState({ value: "" }, () => onChange(id, ""))
                }
              });
            }
          }
        }
      }
    }
    if ((isShipmentLog || isRecipe) && this.state.ingredientOptions?.length > 0) {
      if (defaultLabel == "lotcode_finished") {
        var actual = getComponentSubmit(submission, components, "quantityFinishedGoods", id, position);
        if (actual != this.state.quantity && nextProps.quantityChanged != this.state.quantityChanged && quantityChangedPosition == position) {
          this.setState({ quantity: actual, quantityChanged: nextProps.quantityChanged });
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.onSelectItem(val, false);
        }else if(nextProps.quantityChanged != this.state.quantityChanged){
          this.setState({ quantityChanged: nextProps.quantityChanged });
        }
      }
      if (defaultLabel == "lotcode_wip") {
        var actual = getComponentSubmit(submission, components, "quantityWIP", id, position);
        if (actual != this.state.quantity && nextProps.quantityChanged != this.state.quantityChanged && quantityChangedPosition == position) {
          this.setState({ quantity: actual, quantityChanged: nextProps.quantityChanged });
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.onSelectItem(val, false);
        }else if(nextProps.quantityChanged != this.state.quantityChanged){
          this.setState({ quantityChanged: nextProps.quantityChanged });
        }
      }
      if (defaultLabel == "lotcode" && isShipmentLog) {
        const actualIngredient = getComponentSubmit(submission, components, "quantityIngredient", id, position);
        const actualPackaging = getComponentSubmit(submission, components, "quantityPackaging", id, position);
        const quantityChangedNow = nextProps.quantityChanged !== this.state.quantityChanged;
        
        if (actualIngredient != this.state.quantity && quantityChangedNow && quantityChangedPosition == position) {
          this.setState({ quantity: actualIngredient, quantityChanged: nextProps.quantityChanged });
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.onSelectItem(val, false);
        } else if (actualPackaging != this.state.quantity && quantityChangedNow && quantityChangedPosition == position) {
          this.setState({ quantity: actualPackaging, quantityChanged: nextProps.quantityChanged });
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.onSelectItem(val, false);
        } else if (quantityChangedNow) {
          this.setState({ quantityChanged: nextProps.quantityChanged });
        }
      }
      
      if (defaultLabel == "lotcode" && isRecipe) {
        var actual = getComponentSubmit(submission, components, "quantity", id, position);
        var past = getComponentSubmit(this.props.submission, components, "quantity", id, position);
        if (actual != past && this.props.quantityChanged != nextProps.quantityChanged) {
          var p = (position + 1) * 300;
          var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
          this.setState({ loadingBatchSizeChange: true });
          setTimeout(() => {
            this.onSelectItem(val, false);
            setTimeout(() => this.setState({ loadingBatchSizeChange: false }), 200);
          }, p);
        }
      }

    }else if(defaultLabel == "lotcode" && isReceivingLog){
      //For receiving log form logic
      var actual = getComponentSubmit(submission, components, "quantity", id, position);
      var past = getComponentSubmit(this.props.submission, components, "quantity", id, position);
      if (actual != past && this.props.quantityChanged != nextProps.quantityChanged && actual) {
        this.setState({ quantity: actual, quantityChanged: nextProps.quantityChanged });
        var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(this.state.ingredientOptions)));
        this.onSelectItem(val, false);
      }
    }
    //Open Barcode scanner from keyboard text bar (Android)
    if (nextProps.openBarCodeScanner != openBarCodeScanner && nextProps.openBarCodeScanner) {
      this.showScanner(true);
    }
  }
  async handleBarCodeScanned(data) {
    const { onChange, id, options, isShipmentLog, isRecipe, isInvoice, isInventoryTransfer, setOpenBarcode, handleFocusOnElement } = this.props;
    const { value, ingredientOptions } = this.state;
    this.setState({ scan: false }, async () => {
      //Activate sound for barcode
      //const { sound } = await Audio.Sound.createAsync(require('../../../assets/audio/scanner-audio.mp3'));
      //await sound.playAsync();

      var newVal = [];
      if (typeof value == "object") {
        newVal = value
      }
      if (data) {
        if ((isShipmentLog && options?.length > 0) || ((isRecipe || isInvoice || isInventoryTransfer) && ingredientOptions?.length > 0)) {
          //var idx = newVal.findIndex(val => val?.lot == data);
          var optIdx = (isRecipe || isInvoice || isInventoryTransfer) ? ingredientOptions.find(opt => opt?.lot == data) : options.find(opt => opt?.lot == data);

          if (optIdx) {
            newVal = [optIdx];
          } else {
            newVal = data;
          }

          this.setState({ value: newVal });
          onChange(id, newVal);
        } else {
          this.setState({ value: data });
          onChange(id, data);
        }

      }
      if (setOpenBarcode) {
        setOpenBarcode(null);
      }
      //if(handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
    })


  }
  generateLotCode(max, min) {
    const { id, submissionSelected, onChange, lotConsecutive } = this.props;
    var val = submissionSelected?._id ? submissionSelected._id.slice(-8) + lotConsecutive : Math.floor(Math.random() * (max - min) + min);
    val = val.toString();
    this.setState({ value: val });
    onChange(id, val);
  }
  getMinChar(width) {
    var chrs = 26;
    switch (width) {
      case "small":
        chrs = 13
        break;
      case "medium":
        break;
      case "large":
        break;
    }
    return chrs;
  }
  getFirstDiv(width) {
    var val = 19;
    switch (width) {
      case "small":
        val = 11
        break;
      case "medium":
        break;
      case "large":
        break;
    }
    return val;
  }
  getSecondDiv(width) {
    var val = 28;
    switch (width) {
      case "small":
        val = 13
        break;
      case "medium":
        val = 19
        break;
      case "large":
        val = 26;
        break;
    }
    return val;
  }
  getThirdDiv(width) {
    var val = 31;
    switch (width) {
      case "small":
        val = 13
        break;
      case "medium":
        val = 24
        break;
      case "large":
        break;
    }
    return val;
  }
  onSelectItem(val, prepopulate) {
    const { onChange, id } = this.props;

    this.setState({ value: val });
    onChange(id, val, prepopulate);
  }
  showScanner(value) {
    this.setState({ scan: value, scanerCanceled: value ? false : this.state.scanerCanceled });
  }
  renderInputView() {
    const { value } = this.state;
    const { width } = this.props;

    return <View style={{
      ...styles.input,
      borderColor: "#e7e7e7",
      borderRadius: 5,
      borderWidth: 1,
      color: "#424242",
      fontFamily: "Roboto",
      fontSize: 20,
      fontWeight: "400",
      paddingLeft: 10,
      height:
        Platform.OS === 'ios' ?
          this.state.value !== '' ? this.state.heightIOS * getIosCellHeight(width, value) : this.state.heightIOS * getIosCellHeight(width, this.props.placeholder) :
          this.state.value !== '' ? this.state.height * getIosCellHeight(width, value) : this.state.height * getIosCellHeight(width, this.props.placeholder),
      fontStyle: this.state.value == "" || !this.state.value ? 'italic' : 'normal'
    }}></View>;
  }
  onSelectedItemsChange(lotsSelected) {
    const { onSelectItem, initial } = this.props;
    this.onSelectItem(lotsSelected, true);
  }
  filllocationFromLotsView(componentId, location) {
    const { components, onChange, id } = this.props;
    var locationComponent = getComponentByanotherComponentId(componentId, "location", components);
    if (locationComponent) {
      onChange(id, location);
    }
  }
  isInventoryForm() {
    const { isRequisitionForm, isShipmentLog, isReceivingLog, isInvoice, isInventoryTransfer, isRecipe, isOrder } = this.props;
    return !!(isRequisitionForm || isShipmentLog || isReceivingLog || isInvoice || isInventoryTransfer || isRecipe || isOrder);
  }
  gotLotDefaultLabel(defaultLabel) {
    return (defaultLabel == "lotcode" || defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip" || defaultLabel == "lot");
  }
  getPreselectedLotCodes(defaultLabel, id, components, submission, position, lotCodes) {
    const { isReceivingLog } = this.props;
    const { value } = this.state;
    var quantity = "";
    var units = "";
    var quantityComponent = null;
    var unitsComponent = null;
    unitsComponent = getComponentByanotherComponentId(id, "units", components);
    var preselectedLots = [];
    if (defaultLabel == "lotcode") {
      quantityComponent = getComponentByanotherComponentId(id, "quantity", components);
      if (!quantityComponent && this.props.isShipmentLog) quantityComponent = getComponentByanotherComponentId(id, "quantityIngredient", components);
      if (!quantityComponent && this.props.isShipmentLog) quantityComponent = getComponentByanotherComponentId(id, "quantityPackaging", components);
    } else if (defaultLabel == "lotcode_finished") {
      quantityComponent = getComponentByanotherComponentId(id, "quantityFinishedGoods", components);
    } else if (defaultLabel == "lotcode_wip") {
      quantityComponent = getComponentByanotherComponentId(id, "quantityWIP", components);
    }
    if (quantityComponent) {
      quantity = getComponentSubmissionByDefaultLabel(quantityComponent.defaultLabel, components, submission, quantityComponent.section_id, position);
    }
    if (unitsComponent) {
      units = getComponentSubmissionByDefaultLabel(unitsComponent?.defaultLabel, components, submission, unitsComponent?.section_id, position);
    }
    if (quantity) quantity = parseFloat(quantity);
    if (quantity > 0) {
      
        lotCodes.map((lotCode, idx) => {
          if (quantity > 0) {
            if (lotCode?.historial) {
              lotCode.historial.reverse().map((batch) => {
                if (quantity > 0) {
                  var rest = batch?.amount - quantity;
                  if (rest >= 0) {
                    batch.editedAmount = (quantity % 1 > 0 && !validateDecimals(quantity.toString())) ? quantity.toFixed(3) : quantity;
                    quantity = 0;
                  } else {
                    quantity = rest * -1;
                    batch.editedAmount = (batch?.amount % 1 > 0 && !validateDecimals(batch.amount.toString())) ? parseFloat(batch?.amount).toFixed(3) : parseFloat(batch.amount);
                  }
                } else {
                  batch.hide = true;
                }

                return batch;
              })
            }
            preselectedLots.push(lotCode);
          }
        })
      if (quantity > 0) {
        if(isReceivingLog && (value.length > 0 && typeof value == "object")){
          var quantityOnlOts = 0;
          value.map((lotCode) => {
            quantityOnlOts += parseFloat(lotCode.editedAmount);
          });
          if(quantityOnlOts < quantity || quantityOnlOts > quantity){
            //Need to repart the quantity in the different existent lot codes
            var dividedQuantity = (quantity / value.length).toFixed(3);
            value.map((lotCode) => {
              lotCode.editedAmount = dividedQuantity;
              quantity = quantity - parseFloat(dividedQuantity);
            });
            preselectedLots = value;
            return preselectedLots;
          }
          return value;
          
        }
        preselectedLots.push({
          lot: "",
          historial: [],
          minDate: "",
          production_date: "",
          totalAmount: 0,
          editedAmount: (quantity % 1 > 0 && !validateDecimals(quantity.toString())) ? quantity.toFixed(3) : quantity,
          isNew: true,
          units
        })
      }
    } else {
      preselectedLots = lotCodes?.length ? [lotCodes[0]] : [];
    }
    return preselectedLots;
  }
  inputBlur(blur) {
    if (this.textInputRef.current) {
      this.setState({ leftWriting: true });
      if (blur) this.textInputRef.current.blur();
    }
    if(this._interval)clearTimeout(this._interval);
  }
  showScannerInput() {
    const { setFormScroll } = this.props;
    if (!this.state.scanerCanceled) {
      if (setFormScroll) setFormScroll(false);
      setTimeout(() => {
        this.showScanner(true);
        setTimeout(() => {
          if (setFormScroll) setFormScroll(true);
        }, 300);
      }, 500);
    } else {
      this.setState({ scanerCanceled: false });
    }
  }
  preventModalScroll(setFormScroll, callback) {
    if (setFormScroll) setFormScroll(false);
    const scheduledGen = this._lotsViewGen;
    setTimeout(() => {
      if (scheduledGen !== this._lotsViewGen) return;
      if (callback) callback();
      setTimeout(() => {
        if (scheduledGen !== this._lotsViewGen) return;
        if (setFormScroll) setFormScroll(true);
      }, 300);
    }, 300);
  }
  render() {
    const { value, scan, reset, ingredientOptions, showLotsByLocation, leftWriting, loadedLots, loadingBatchSizeChange, scanerCanceled, softFocus } = this.state;
    const { label, onChange, id, isIssuable, onSubmitIssue, isCompleted, showScanner, showLotGenerator, width, openIssue, defaultComponent, handleFocusOnElement, showInventorySearch, defaultLabel, isShipmentLog, options, submission, showWipSearch, isRecipe, isInvoice, isInventoryTransfer, openDropDown, backgroundColor, isDropDownOpened, closeSearch, hideInput, components, position, setShowTextBar, setOpenBarcode, openBarCodeScanner, scannerInput, rerenderTable, minorAmountAndroid, minorAmountPosition, newReport, isInventoryReceivingForm, isReceivingLog, defaultYield, setFormScroll } = this.props;
    const type = defaultLabel == "lotcode_finished" ? "Finished goods" : defaultLabel == "lotcode_wip" ? "Work in progress" : showWipSearch ? "Work in progress" : "";
    const requiredAmount = isInventoryReceivingForm ? getRequiredAmount(components, id, position, isRecipe, submission, defaultLabel, defaultYield) : 0;
    var minorAmount = false;
    //const isInventoryForm = this.isInventoryForm();
    if (isRecipe)
      if (newReport) {
        minorAmount = ((parseFloat(getTotalSelected(value)) < parseFloat(requiredAmount) || parseFloat(getTotalSelected(value)) > parseFloat(requiredAmount)) && loadedLots && !loadingBatchSizeChange);
      } else {
        minorAmount = (parseFloat(getTotalSelected(value)) < parseFloat(requiredAmount) || parseFloat(getTotalSelected(value)) > parseFloat(requiredAmount) && !loadingBatchSizeChange);
      }

    var ingredientName = "";
    var units = "";
    var amount = "";

    if (isInventoryReceivingForm) {
      ingredientName = getComponentSubmit(submission, components, "ingredient", id, position);
      if (!ingredientName) ingredientName = getComponentSubmit(submission, components, "name", id, position);
      if (!ingredientName) ingredientName = getComponentSubmit(submission, components, "item", id, position);

      amount = getComponentSubmit(submission, components, "quantity", id, position);
      if (!amount) amount = getComponentSubmit(submission, components, "quantityIngredient", id, position);
      if (!amount) amount = getComponentSubmit(submission, components, "quantityFinishedGoods", id, position);
      if (!amount) amount = getComponentSubmit(submission, components, "quantityWIP", id, position);
      if (amount) amount = parseFloat(amount);
    }

    if (isInventoryReceivingForm) units = getComponentSubmit(submission, components, "units", id, position);

    const openLotsForMobile = shouldOpenLotsPickerMobile(
      isInventoryReceivingForm,
      options,
      ingredientOptions,
      ingredientName,
      amount
    );
    const canOpenEmbeddedLotsFromRow =
      lotFieldHasMeaningfulLots(value) ||
      ((typeof value === "string" && value.trim().length > 0) ||
      (Array.isArray(value) && value.length > 0))
      &&
      (isInventoryReceivingForm && receivingRowHasProductForLotsPicker(ingredientName, amount));

    return (
      <View ref={this.inputRef}>
        {scan ?
          <View style={{
            ...styles.container,
            paddingTop: width ? 0 : 5
          }}>
            <BarcodeScannerComponent
              onBarCodeScanned={(e) => {
                this.handleBarCodeScanned(e);
              }}
              closeScanner={() => {
                this.showScanner(false);
                if (scannerInput && (showScanner || isInventoryReceivingForm)) {
                  this.setState({ scanerCanceled: true }, () => {
                    setTimeout(() => {
                      if (inputFocus) inputFocus(this.textInputRef);
                    }, 200);
                  })
                }
              }}
              style={styles.absoluteFillObject}
            />
          </View>

          :
          <>
            {showLotsByLocation ?
              <LotsByLocation units={units} amount={amount} lotsSelected={value} options={options ? options : []} id={id} position={position} name={ingredientName} onBack={(editQty, totalSelected, minorAmount) => {
                this._lotsViewGen++;
                this._embeddedLotsClosedUntil = Date.now() + 900;
                this.inputBlur(true);
                setTimeout(() => {
                  this.setState({ showLotsByLocation: false, minorAmount });
                }, 100);
                //Edit Qty
                if (
                  //!isRecipe && 
                  onChange && editQty
                ) {
                  var quantityComponent = null;
                  if (isShipmentLog) {
                    if (defaultLabel == "lotcode_finished") {
                      quantityComponent = getComponentByanotherComponentId(id, "quantityFinishedGoods", components);
                    } else if (defaultLabel == "lotcode_wip") {
                      quantityComponent = getComponentByanotherComponentId(id, "quantityWIP", components);
                    } else if (getComponentByanotherComponentId(id, "quantityIngredient", components)) {
                      quantityComponent = getComponentByanotherComponentId(id, "quantityIngredient", components);
                    } else {
                      quantityComponent = getComponentByanotherComponentId(id, "quantityPackaging", components);
                    }
                  } else {
                    quantityComponent = getComponentByanotherComponentId(id, "quantity", components);
                  }
                  if (quantityComponent) onChange(quantityComponent.id, totalSelected, false)
                }
              }} placeholder={"Search by lot code"} onSelect={(selected, location) => {
                this.onSelectedItemsChange(selected);
                if (isRecipe && location) this.filllocationFromLotsView(id, location);
              }} filllocationFromLotsView={(location) => this.filllocationFromLotsView(id, location)} components={components} openAlert={(value) => this.setState({ showLotsByLocation: !value })} requiredAmount={requiredAmount} isInventoryReceivingForm={isInventoryReceivingForm} isInventoryType={defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip"} isReceivingLog={isReceivingLog} setFormScroll={setFormScroll} isRecipe={isRecipe} isShipmentLog={isShipmentLog}/> : null
            }
            {(this.state.dialogVisible && !width) &&
              <NewIssue
                id={id}
                label={label}
                onSubmitIssue={onSubmitIssue}
                handleClose={() => this.setState({ dialogVisible: false })}
              />
            }
            {!this.state.dialogVisible &&
              <View style={{
                ...styles.container,
                paddingTop: width ? 0 : 5
              }}>
                {
                  label ?
                    <Text style={styles.label}>
                      {label}
                    </Text>
                    : null
                }
                {
                  (isIssuable && isCompleted) &&
                  <TouchableOpacity style={{ paddingBottom: 10, paddingTop: 5 }} onPress={() => {
                    if (width) {
                      openIssue();
                    } else {
                      this.setState({ dialogVisible: true });
                    }
                  }}>
                    <Text style={{ color: colors.primary, fontWeight: 'bold' }}>Issue</Text>
                  </TouchableOpacity>
                }
                <View style={styles.inputContainer}>
                  <View style={styles.inputC}>
                    {
                      (showInventorySearch && (!isShipmentLog && !isRecipe && !isInvoice && !isInventoryTransfer)) &&
                      <SearchInventory onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if (scannerInput && (showScanner || isInventoryReceivingForm)) {
                          this.showScanner(true);
                        }
                      }} closeSearch={closeSearch} showScanner={showScanner} defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} type={type} searchBy={'lot'} isShipmentLog={isShipmentLog} options={options} defaultLabel={defaultLabel} reset={reset} id={id} submission={submission} openDropDown={openDropDown} backgroundColor={backgroundColor} isDropDownOpened={isDropDownOpened} />
                    }
                    {/* //For recipes */}
                    {
                      ((showInventorySearch || (isShipmentLog && defaultLabel == "lotcode")) && (ingredientOptions?.length > 0) && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog)) &&
                      <SearchIngredientsByLot showScanner={showScanner} defaultComponent={defaultComponent} onSelectItem={(val) => {
                        if (isRecipe && defaultLabel == "lotcode")
                          this.onSelectItem(val, true);
                        else
                          this.onSelectItem(val);
                      }} onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if (scannerInput && (showScanner || isInventoryReceivingForm)) {
                          this.showScanner(true);
                        }
                      }} closeSearch={closeSearch} initial={value} type={type} searchBy={'lot'} isRecipe={isRecipe} isInvoice={isInvoice} isInventoryTransfer={isInventoryTransfer} options={ingredientOptions} defaultLabel={defaultLabel} reset={reset} id={id} submission={submission} width={width} isShipmentLog={isShipmentLog} openDropDown={openDropDown} backgroundColor={backgroundColor} isDropDownOpened={isDropDownOpened} components={components} position={position} setShowTextBar={setShowTextBar} scanOptionPress={() => {
                        this.showScanner(true);
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                      }} ingredientName={ingredientName} units={units} amount={amount} rerenderTable={rerenderTable} gotLotDefaultLabel={this.gotLotDefaultLabel(defaultLabel)} onChange={onChange} minorAmountAndroid={minorAmountAndroid} minorAmount={minorAmount} requiredAmount={requiredAmount} isInventoryReceivingForm={isInventoryReceivingForm} isReceivingLog={isReceivingLog} isInventoryForm={this.isInventoryForm()} setFormScroll={setFormScroll} />
                    }
                    {
                      (!(showInventorySearch && (!isShipmentLog && !isRecipe && !isInvoice && !isInventoryTransfer)) &&
                        !((showInventorySearch || (isShipmentLog && defaultLabel == "lotcode")) && (ingredientOptions?.length > 0) && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog))) ?
                        hideInput ? this.renderInputView() :
                          <View
                            style={{
                              flexDirection: (isInventoryReceivingForm && defaultLabel != "lot") ? 'row' : 'column',
                              justifyContent: (isInventoryReceivingForm && defaultLabel != "lot") ? 'center' : 'none',
                              alignItems: (isInventoryReceivingForm && defaultLabel != "lot") ? 'center' : 'none',
                              //paddingInline: (isInventoryReceivingForm && defaultLabel != "lot") ? 5 : 0,
                              borderRadius: (isInventoryReceivingForm && defaultLabel != "lot") ? 20 : 0,
                              //backgroundColor: 'red',
                              paddingInline: (isInventoryReceivingForm && defaultLabel != "lot") && typeof value == "object" ? 12 : 0,
                              backgroundColor: (isInventoryReceivingForm && defaultLabel != "lot") ? typeof value == "object" && minorAmount ? colors.quit : colors.primary : 'none',
                            }}
                          >
                            <TextInput
                              {...getNoAutofillProps()}
                              //value={typeof value == "string" ? value : ""}
                              value={typeof value == "string" ? value : typeof value == "object" ? getLotCodeString(value) : ""}
                              editable={!defaultComponent && !(isRecipe && ingredientName.trim().toLowerCase() == "water") && !(scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled && Platform.OS == "ios")}
                              ref={noAutofillRef(this.textInputRef)}
                              showSoftInputOnFocus={Platform.OS == "ios" ? true : softFocus}
                              onPress={() => {
                                if (scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled) {
                                  if (canOpenEmbeddedLotsFromRow) {
                                    if (!this.shouldAllowEmbeddedLotsView()) return;
                                    this._lotsViewGen++;
                                    this.setState({ showLotsByLocation: true });
                                  } else {
                                    this.showScannerInput();
                                  }
                                }
                              }}
                              onBlur={() => {
                                if (scannerInput && (showScanner || isInventoryReceivingForm)) {
                                  this.setState({ scanerCanceled: false });
                                  if (softFocus) this.setState({ softFocus: false });
                                }
                              }}
                              onFocus={() => {
                                /* Web restores focus to the TextInput when LotsByLocation Modal unmounts; skip reopen / scroll side effects for a short window after onBack. */
                                if (Platform.OS === "web" && !this.shouldAllowEmbeddedLotsView()) {
                                  return;
                                }
                                setTimeout(() => {
                                  if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                                }, 300);
                                /* Skip onFocus body when scanner + lots already set; empty [] is false so setShowTextBar can still open form lots. */
                                if (scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled && lotFieldHasMeaningfulLots(value)) {
                                  return;
                                }
                                if (isInventoryReceivingForm && defaultLabel != "lot") {
                                  if (canOpenEmbeddedLotsFromRow) {
                                    if (leftWriting) {
                                      if (!this.shouldAllowEmbeddedLotsView()) return;
                                      this.preventModalScroll(setFormScroll, () => {
                                        if (!this.shouldAllowEmbeddedLotsView()) return;
                                        this.setState({ showLotsByLocation: true }, () => { });
                                      });
                                      return;
                                    }
                                  } else {
                                    if (Platform.OS != "ios" && scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled) {
                                      this.showScannerInput();
                                      if (!softFocus) {
                                        this.setState({ softFocus: true });
                                        return;
                                      }
                                    }
                                  }
                                  this.preventModalScroll(setFormScroll, () => {
                                    const openLotsNow =
                                      openLotsForMobile && this.shouldAllowEmbeddedLotsView();
                                    /* Mobile web (iOS or Android browser) and native Android: open via Form#setShowTextBar. Native iOS: open embedded LotsByLocation. */
                                    const usesKeyboardBar = isMobileWeb() || Platform.OS === "android";
                                    if (isInventoryReceivingForm && setShowTextBar && usesKeyboardBar && this.gotLotDefaultLabel(defaultLabel)) {
                                      if (!(isRecipe && ingredientName.trim().toLowerCase() == "water")) {
                                        setShowTextBar(id, position, [], ingredientName, value, units, amount, openLotsNow);
                                      }
                                    } else if (isInventoryReceivingForm && setShowTextBar && Platform.OS === "ios" && openLotsNow) {
                                      if (!this.shouldAllowEmbeddedLotsView()) return;
                                      this._lotsViewGen++;
                                      this.setState({ showLotsByLocation: true });
                                    }
                                  });
                                } else {
                                  if (Platform.OS != "ios" && scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled) {
                                    this.showScannerInput();
                                    if (!softFocus) {
                                      this.setState({ softFocus: true });
                                      return;
                                    }
                                  }
                                  if (setShowTextBar) {
                                    setShowTextBar(null, null, null, null, null, null, null, false)
                                  }
                                }
                              }}
                              inputAccessoryViewID={this.state.inputAccessoryViewID}
                              scrollEnabled={isRecipe ? false : true}
                              style={{
                                ...styles.input,
                                paddingTop: (isRecipe && Platform.OS == "ios" && defaultLabel == "lot") ? 10 : isInventoryReceivingForm ? 5 : 0,
                                justifyContent: (isRecipe && Platform.OS == "ios" && defaultLabel == "lot") ? "center" : "flex-end",
                                borderColor: (isInventoryReceivingForm && defaultLabel == "lot") ? colors.orange : "#e7e7e7",
                                borderRadius: (isInventoryReceivingForm && defaultLabel != "lot") ? 20 : (isInventoryReceivingForm && defaultLabel == "lot") ? 10 : 5,
                                borderWidth: ((isInventoryReceivingForm && width && defaultLabel != "lot")) ? 0 : 1,
                                color: isInventoryReceivingForm ? defaultLabel == "lot" ? colors.orange : 'white' : "#424242",
                                fontFamily: "Roboto",
                                fontSize: isInventoryReceivingForm ? 14 : 20,
                                fontWeight: "400",
                                //paddingLeft: 10,
                                padding: isInventoryReceivingForm ? 5 : 10,
                                //paddingVertical: isRecipe ? Platform.OS == "ios" ? 8 : 0 : 0,
                                marginTop: (isInventoryReceivingForm && defaultLabel == "lot") ? 15 : isInventoryReceivingForm ? 0 : 5,
                                textAlign: isInventoryReceivingForm ? 'center' : 'left',
                                backgroundColor: (isInventoryReceivingForm && defaultLabel != "lot") ? typeof value == "object" && minorAmount ? colors.quit : colors.primary : 'none',
                                height:
                                  Platform.OS === 'ios' ?
                                    this.state.value !== '' ? this.state.heightIOS * getIosCellHeight(width, value) : this.state.heightIOS * getIosCellHeight(width, this.props.placeholder) :
                                    this.state.value !== '' ? this.state.height * getIosCellHeight(width, value) : this.state.height * getIosCellHeight(width, this.props.placeholder),
                                fontStyle: this.state.value == "" || !this.state.value ? 'italic' : 'normal',
                                width: isInventoryReceivingForm ? '100%' : 'auto',
                                marginVertical: (isInventoryReceivingForm && defaultLabel != "lot") && typeof value == "object" ? 1 : 0,
                                cursor: isInventoryReceivingForm && defaultLabel == "lotcode" && value && leftWriting ? 'pointer' : 'auto',
                              }}
                              multiline={true}
                              // scrollEnabled={false}
                              placeholder={this.props.placeholder ? this.props.placeholder : ""}
                              placeholderTextColor={(isRecipe && defaultLabel != "lot") ? 'white' : 'rgb(0, 47, 108)'}
                              onChangeText={(val) => {
                                if (!defaultComponent) {
                                  if (isInventoryReceivingForm && defaultLabel != "lot") {
                                    if(this._interval)clearTimeout(this._interval);
                                    this._interval = setTimeout(() => this.inputBlur(false), 500);
                                  }
                                  this.setState({ value: val });
                                  if(isInventoryReceivingForm)this.setState({ softFocus: false });
                                  onChange(id, val);
                                }
                              }}
                            />
                            {typeof value == "object" && value.length > 1 && <Text style={styles.lotsSelectedViewTxt}>+{value?.length - 1}</Text>}
                            {Platform.OS == "ios" && !value && <InputAccessoryView nativeID={this.state.inputAccessoryViewID}>
                              {(isInventoryReceivingForm && !(isRecipe && ingredientName.trim().toLowerCase() == "water")) && !(scannerInput && (showScanner || isInventoryReceivingForm) && !value && !scanerCanceled) && <KeyboardBar abcOptionPress={() => {
                                if (!this.shouldAllowEmbeddedLotsView()) return;
                                this._lotsViewGen++;
                                this.setState({ showLotsByLocation: true });
                              }} scanOptionPress={() => {
                                this.showScanner(true);
                                setTimeout(() => {
                                  if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                                }, 300);
                              }} />}
                            </InputAccessoryView>
                            }
                          </View> : null
                    }
                    {
                      showScanner && !scannerInput && !isInventoryReceivingForm &&
                      <TouchableOpacity style={styles.btnScan}
                        disabled={defaultComponent}
                        onPress={() => {
                          this.showScanner(true);
                          setTimeout(() => {
                            if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                          }, 300);
                        }}
                      >
                        <Text style={styles.txtScan}>
                          Scan
                        </Text>
                      </TouchableOpacity>
                    }
                    {
                      showLotGenerator &&
                      <TouchableOpacity style={styles.btnScan}
                        onPress={() => this.generateLotCode(999999999999, 10000000)}
                      >
                        <Text style={styles.txtScan}>
                          Generate Lot Code
                        </Text>
                      </TouchableOpacity>
                    }

                  </View>

                </View>
              </View>
            }
          </>
        }
      </View>
    );
  }
}
export default connect((state, ownProps = {}) => ({
}), (dispatch, props) => ({
  getIngredientLotsByName: (data, callback) => {
    dispatch(getIngredientLotsByName(data, callback));
  },
  dispatch: dispatch,
}))(Lotcode);

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    // paddingBottom: 10,
    // paddingHorizontal: 10,
    paddingTop: 5,
    flex: 1,
  },
  input: {
    borderColor: "#e7e7e7",
    borderRadius: 5,
    borderWidth: 1,
    color: "#424242",
    fontFamily: "Roboto",
    fontSize: 25,
    fontWeight: "400",
    paddingLeft: 10,
  },
  label: {
    fontSize: 20,
    color: '#939598',
    fontWeight: '300',
    fontFamily: 'Roboto',
  },
  inputContainer: {
    flex: 1,
    flexDirection: "column"
  },
  inputC: {
    flex: 3
  },
  btnC: {
    flex: 1
  },
  btnScan: {
    textAlign: "center",
    justifyContent: "center",
    backgroundColor: colors.primary,
    height: 30,
    borderRadius: 5,
    marginTop: 10
  },
  txtScan: {
    textAlign: "center",
    justifyContent: "center",
    color: "white"
  },
  absoluteFillObject: {
    height: 400,
    width: "100%",
  },
  btnCancel: {
    backgroundColor: colors.orange,
    justifyContent: "center",
    borderRadius: 5,
    marginTop: 10,

  },
  btnCancelText: {
    justifyContent: "center",
    textAlign: "center",
    padding: 5,
    color: "white"
  },
  lotsSelectedViewTxt: {
    color: 'white',
    borderWidth: 1,
    borderRadius: 5,
    padding: 2,
    borderColor: 'white',
    fontSize: 12,
    height: 20,
    //marginRight: 3,
    marginVertical: 4
  }
});
